
























































































































































































































import 'reflect-metadata'
import { Component, Vue } from 'vue-property-decorator'
import { ViewDataFromEmailApi } from '@/api'
import NotificationWithOutExit from "@/components/common/notification/NotificationWithOutExit.vue"

@Component({
    components: {
        'common-notification-notification': NotificationWithOutExit
    }
})
export default class EmailAlertDaily extends Vue {
    loading: boolean = false
    
    isData: boolean = false
    username: string = ""
    email: string = ""
    readDate: string = ""
    projectName: string = ""
    transferDate: string = ""
    unitGroupList: any = []
    headerDate: string = ""

    unitListPJPlanNo1: any = []
    unitListPJPlanNo2: any = []
    unitListPJPlanNo3: any = []
    unitListPJPlanNo4: any = []

    projectLists = [] as any

    async mounted() {
        await this.SetGetReportEmailTransfer()
    }

    async SetGetReportEmailTransfer() {
        try {
            this.loading = true
            const qs = this.$route.query
            const projectId = qs.pid ?? ""

            if (projectId === "") {
                this.loading = false
                throw new Error()
            }

            const response = await ViewDataFromEmailApi.GetEmailAlertDaily({
                projectId: projectId,
            })

            this.headerDate = `${response.readDate.split(' ')[0]}`
            this.username = `${response.userName}`
            this.email = `${response.email}`
            this.readDate = `${response.readDate}`
            this.projectName = `${response.projectCode} ${response.projectName}`
            
            this.unitListPJPlanNo1 = response.unitListPJPlanNo1
            this.unitListPJPlanNo2 = response.unitListPJPlanNo2
            this.unitListPJPlanNo3 = response.unitListPJPlanNo3
            this.unitListPJPlanNo4 = response.unitListPJPlanNo4

            this.loading = false
            this.isData = true

        } catch (error) {
            this.isData = false
            this.notification('มีข้อผิดพลาดเกิดขึ้น โปรดลองใหม่อีกครั้ง', 'warning') 
        }
    }

    notification (text: string, status: string) {
        const child = this.$refs.refNotification as any
        child.openNotification(text, status)
    }
}
